import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ProductsService {
   public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': localStorage.getItem("session")
    })
  };
  public myurl=url+"material/";
  constructor(private http:HttpClient) {
    //console.log(this.myurl);
   }
  
  getListProducts(){
   return this.http.get(this.myurl+"listProducts.php").pipe(map(res=>{
      return res;
    }));
  }

  getListProductsContinue(page,filtro){
    return this.http.get(this.myurl+"listProducts.php?page="+page+"&filtro="+filtro).pipe(map(res=>{
       return res;
     }));
   }
  getListProductsId(id){
    let headers=new HttpHeaders();
    let body=JSON.stringify(id);
    headers.append('Content-Type' , 'application/json');
   
    return this.http.post(this.myurl+"getProductsId.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }))
   }
  createProduct(product:any){
    let headers=new HttpHeaders();
   
    headers.append('Content-Type' , 'application/json');
    let body=JSON.stringify(product);
   
   
    return this.http.post(this.myurl+"CreateNewProduct.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }))
  }
  createProductList(product:any){
    let headers=new HttpHeaders();
   
    headers.append('Content-Type' , 'application/json');
    let body=JSON.stringify(product);
   
   
    return this.http.post(this.myurl+"createNewProductList.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }))
  }
  updateProduct(product:any){
    let headers=new HttpHeaders();
    let body=JSON.stringify(product);
    headers.append('Content-Type' , 'application/json');
   
    return this.http.put(this.myurl+"updateProduct.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }));
  }
  deleteProduct(id){
    let headers=new HttpHeaders();
   
    headers.append('Content-Type' , 'application/json');
    return this.http.delete(this.myurl+"deleteProduct.php?id="+id,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }
}
